
import Task from "../../../assets/filled/Task.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TaskIcon({ className, dataTestid = "TaskIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Task data-testid={dataTestid} className={classes} {...rest} />
  );
}
